import React, { useState } from 'react';
import { useGameStore } from '../store/gameStore';

// Zahlenformat-Guide Komponente
const NumberFormatGuide: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const numberFormats = [
    { suffix: 'K', name: 'Tausend', value: '1.000' },
    { suffix: 'M', name: 'Million', value: '1.000.000' },
    { suffix: 'B', name: 'Milliarde', value: '1.000.000.000' },
    { suffix: 'T', name: 'Billion', value: '1.000.000.000.000' },
    { suffix: 'Q', name: 'Quadrillion', value: '1.000.000.000.000.000' },
    { suffix: 'Qi', name: 'Quintillion', value: '1.000.000.000.000.000.000' },
    { suffix: 'Sx', name: 'Sextillion', value: '1.000.000.000.000.000.000.000' },
    { suffix: 'Sp', name: 'Septillion', value: '1e24' },
    { suffix: 'Oc', name: 'Octillion', value: '1e27' },
    { suffix: 'No', name: 'Nonillion', value: '1e30' },
    { suffix: 'Dc', name: 'Decillion', value: '1e33' },
    { suffix: 'UDc', name: 'Undecillion', value: '1e36' },
    { suffix: 'DDc', name: 'Duodecillion', value: '1e39' },
    { suffix: 'TDc', name: 'Tredecillion', value: '1e42' },
    { suffix: 'QaDc', name: 'Quattuordecillion', value: '1e45' },
    { suffix: 'QiDc', name: 'Quindecillion', value: '1e48' },
    { suffix: 'SxDc', name: 'Sexdecillion', value: '1e51' },
    { suffix: 'SpDc', name: 'Septendecillion', value: '1e54' },
    { suffix: 'OcDc', name: 'Octodecillion', value: '1e57' },
    { suffix: 'NoDc', name: 'Novemdecillion', value: '1e60' },
    { suffix: 'Vg', name: 'Vigintillion', value: '1e63' },
    { suffix: 'UVg', name: 'Unvigintillion', value: '1e66' },
    { suffix: 'DVg', name: 'Duovigintillion', value: '1e69' },
    { suffix: 'TVg', name: 'Trevigintillion', value: '1e72' },
    { suffix: 'QaVg', name: 'Quattuorvigintillion', value: '1e75' },
    { suffix: 'QiVg', name: 'Quinvigintillion', value: '1e78' },
    { suffix: 'SxVg', name: 'Sexvigintillion', value: '1e81' },
    { suffix: 'SpVg', name: 'Septenvigintillion', value: '1e84' },
    { suffix: 'OcVg', name: 'Octovigintillion', value: '1e87' },
    { suffix: 'NoVg', name: 'Novemvigintillion', value: '1e90' },
    { suffix: 'Tg', name: 'Trigintillion', value: '1e93' },
    { suffix: 'UTg', name: 'Untrigintillion', value: '1e96' },
    { suffix: 'DTg', name: 'Duotrigintillion', value: '1e99' },
    { suffix: 'TTg', name: 'Tretrigintillion', value: '1e102' },
    { suffix: 'QaTg', name: 'Quattuortrigintillion', value: '1e105' },
    { suffix: 'QiTg', name: 'Quintrigintillion', value: '1e108' },
    { suffix: 'SxTg', name: 'Sextrigintillion', value: '1e111' },
    { suffix: 'SpTg', name: 'Septentrigintillion', value: '1e114' },
    { suffix: 'OcTg', name: 'Octotrigintillion', value: '1e117' },
    { suffix: 'NoTg', name: 'Novemtrigintillion', value: '1e120' },
    { suffix: 'Qa', name: 'Quadragintillion', value: '1e123' },
    { suffix: 'UQa', name: 'Unquadragintillion', value: '1e126' },
    { suffix: 'DQa', name: 'Duoquadragintillion', value: '1e129' },
    { suffix: 'TQa', name: 'Trequadragintillion', value: '1e132' },
    { suffix: 'QaQa', name: 'Quattuorquadragintillion', value: '1e135' },
    { suffix: 'QiQa', name: 'Quinquadragintillion', value: '1e138' },
    { suffix: 'SxQa', name: 'Sexquadragintillion', value: '1e141' },
    { suffix: 'SpQa', name: 'Septenquadragintillion', value: '1e144' },
    { suffix: 'OcQa', name: 'Octoquadragintillion', value: '1e147' },
    { suffix: 'NoQa', name: 'Novemquadragintillion', value: '1e150' },
    { suffix: 'Qn', name: 'Quinquagintillion', value: '1e153' },
    { suffix: 'UQn', name: 'Unquinquagintillion', value: '1e156' },
    { suffix: 'DQn', name: 'Duoquinquagintillion', value: '1e159' },
    { suffix: 'TQn', name: 'Trequinquagintillion', value: '1e162' },
    { suffix: 'QaQn', name: 'Quattuorquinquagintillion', value: '1e165' },
    { suffix: 'QiQn', name: 'Quinquinquagintillion', value: '1e168' },
    { suffix: 'SxQn', name: 'Sexquinquagintillion', value: '1e171' },
    { suffix: 'SpQn', name: 'Septenquinquagintillion', value: '1e174' },
    { suffix: 'OcQn', name: 'Octoquinquagintillion', value: '1e177' },
    { suffix: 'NoQn', name: 'Novemquinquagintillion', value: '1e180' },
    { suffix: 'Sx', name: 'Sexagintillion', value: '1e183' },
    { suffix: 'USx', name: 'Unsexagintillion', value: '1e186' },
    { suffix: 'DSx', name: 'Duosexagintillion', value: '1e189' },
    { suffix: 'TSx', name: 'Tresexagintillion', value: '1e192' },
    { suffix: 'QaSx', name: 'Quattuorsexagintillion', value: '1e195' },
    { suffix: 'QiSx', name: 'Quinsexagintillion', value: '1e198' },
    { suffix: 'SxSx', name: 'Sexsexagintillion', value: '1e201' },
    { suffix: 'SpSx', name: 'Septensexagintillion', value: '1e204' },
    { suffix: 'OcSx', name: 'Octosexagintillion', value: '1e207' },
    { suffix: 'NoSx', name: 'Novemsexagintillion', value: '1e210' },
    { suffix: 'Sp', name: 'Septuagintillion', value: '1e213' },
    { suffix: 'USp', name: 'Unseptuagintillion', value: '1e216' },
    { suffix: 'DSp', name: 'Duoseptuagintillion', value: '1e219' },
    { suffix: 'TSp', name: 'Treseptuagintillion', value: '1e222' },
    { suffix: 'QaSp', name: 'Quattuorseptuagintillion', value: '1e225' },
    { suffix: 'QiSp', name: 'Quinseptuagintillion', value: '1e228' },
    { suffix: 'SxSp', name: 'Sexseptuagintillion', value: '1e231' },
    { suffix: 'SpSp', name: 'Septenseptuagintillion', value: '1e234' },
    { suffix: 'OcSp', name: 'Octoseptuagintillion', value: '1e237' },
    { suffix: 'NoSp', name: 'Novemseptuagintillion', value: '1e240' },
    { suffix: 'Oc', name: 'Octogintillion', value: '1e243' },
    { suffix: 'UOc', name: 'Unoctogintillion', value: '1e246' },
    { suffix: 'DOc', name: 'Duooctogintillion', value: '1e249' },
    { suffix: 'TOc', name: 'Treoctogintillion', value: '1e252' },
    { suffix: 'QaOc', name: 'Quattuoroctogintillion', value: '1e255' },
    { suffix: 'QiOc', name: 'Quinoctogintillion', value: '1e258' },
    { suffix: 'SxOc', name: 'Sexoctogintillion', value: '1e261' },
    { suffix: 'SpOc', name: 'Septenoctogintillion', value: '1e264' },
    { suffix: 'OcOc', name: 'Octooctogintillion', value: '1e267' },
    { suffix: 'NoOc', name: 'Novemoctogintillion', value: '1e270' },
    { suffix: 'No', name: 'Nonagintillion', value: '1e273' },
    { suffix: 'UNo', name: 'Unnonagintillion', value: '1e276' },
    { suffix: 'DNo', name: 'Duononagintillion', value: '1e279' },
    { suffix: 'TNo', name: 'Trenonagintillion', value: '1e282' },
    { suffix: 'QaNo', name: 'Quattuornonagintillion', value: '1e285' },
    { suffix: 'QiNo', name: 'Quinnonagintillion', value: '1e288' },
    { suffix: 'SxNo', name: 'Sexnonagintillion', value: '1e291' },
    { suffix: 'SpNo', name: 'Septennonagintillion', value: '1e294' },
    { suffix: 'OcNo', name: 'Octononagintillion', value: '1e297' },
    { suffix: 'NoNo', name: 'Novemnonagintillion', value: '1e300' },
    { suffix: 'Ce', name: 'Centillion', value: '1e303' },
    { suffix: 'Ce+', name: 'Über Centillion', value: '1e306+' },
  ];

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border-2 border-blue-200 overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-3 sm:p-4 flex items-center justify-between text-blue-700 hover:bg-blue-100/50 transition-colors touch-manipulation"
      >
        <div className="flex items-center gap-2 sm:gap-3">
          <span className="text-xl sm:text-2xl">🔢</span>
          <span className="text-base sm:text-lg font-bold">Zahlenformat-Übersetzungen</span>
        </div>
        <div
          className={`transform transition-transform duration-200 ${
            isExpanded ? 'rotate-180' : 'rotate-0'
          }`}
        >
          <span className="text-lg sm:text-xl">▼</span>
        </div>
      </button>

      {isExpanded && (
        <div className="px-3 sm:px-4 pb-3 sm:pb-4">
          <div className="bg-blue-100/50 rounded-lg p-2 sm:p-3 mb-3 sm:mb-4">
            <div className="text-xs sm:text-sm text-blue-700">
              <strong>💡 Info:</strong> Diese Abkürzungen werden verwendet, um sehr große Zahlen kompakt darzustellen.
              Beispiel: <code className="bg-blue-200 px-1 rounded text-xs sm:text-sm">1.5M</code> = 1.500.000 Münzen
            </div>
          </div>
          
          {/* Mobile-optimiertes Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1.5 sm:gap-2 max-h-64 sm:max-h-96 overflow-y-auto scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-transparent">
            {numberFormats.map((format, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-2 sm:p-3 border border-blue-200 hover:bg-blue-50 transition-colors"
              >
                <div className="flex items-center justify-between mb-1">
                  <span className="font-bold text-blue-600 text-base sm:text-lg">{format.suffix}</span>
                  <span className="text-xs text-gray-500">{format.value}</span>
                </div>
                <div className="text-xs sm:text-sm text-gray-700 leading-tight">{format.name}</div>
              </div>
            ))}
          </div>
          
          <div className="mt-3 sm:mt-4 p-2 sm:p-3 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-lg">
            <div className="text-xs sm:text-sm text-blue-700">
              <strong>🚀 Tipp:</strong> Das Spiel unterstützt Zahlen bis zu Centillion (1e303) und darüber hinaus!
              Die größten Idle-Games erreichen normalerweise nur bis Octillion oder Nonillion.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

interface StatsOverlayProps {
  isOpen?: boolean;
  onToggle?: () => void;
  onOpenSettings?: () => void;
}

const StatsOverlay: React.FC<StatsOverlayProps> = ({ isOpen: externalIsOpen, onToggle, onOpenSettings }) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;
  const { 
    coins, 
    gems, 
    experience,
    playerLevel, 
    autoClickPower,
    prestige, 
    upgrades,
    gardenAreas,
    powerUps,
    companions,
    achievements,
    globalMultipliers,
    getClickMultiplier,
    getTotalCoinsPerSecond,
    getMegaPrestigeMultiplier,
    getCompanionBonus,
    getAreaBonus,
    formatNumber,
  } = useGameStore();

  const clickMultiplier = getClickMultiplier();
  const coinsPerSecond = getTotalCoinsPerSecond();
  const megaPrestigeMultiplier = getMegaPrestigeMultiplier();

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-start justify-center p-4 modal-container">
          <div className="bg-white rounded-lg max-w-7xl w-full max-h-[90vh] overflow-y-auto shadow-2xl mt-4 z-[9999] modal-content">
            <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-t-lg shadow-lg z-10">
              <div className="flex justify-between items-center">
                <h2 className="text-xl sm:text-2xl font-bold">📊 Detaillierte Statistiken</h2>
                <button
                  onClick={() => onToggle ? onToggle() : setInternalIsOpen(false)}
                  className="text-white hover:text-red-300 hover:bg-red-500/20 text-3xl font-bold px-3 py-1 rounded-full transition-all duration-200 transform hover:scale-110 active:scale-95 touch-manipulation min-w-[48px] min-h-[48px] flex items-center justify-center"
                  title="Schließen"
                >
                  ×
                </button>
              </div>
            </div>

            <div className="p-6 space-y-6">
              {/* Grundlegende Statistiken */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-blue-50 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-blue-600">{formatNumber(coins)}</div>
                  <div className="text-sm text-gray-600">💰 Münzen</div>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-purple-600">{formatNumber(gems)}</div>
                  <div className="text-sm text-gray-600">💎 Edelsteine</div>
                </div>
                <div className="bg-green-50 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-green-600">{formatNumber(experience)}</div>
                  <div className="text-sm text-gray-600">⭐ Erfahrung</div>
                </div>
                <div className="bg-yellow-50 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-yellow-600">{playerLevel}</div>
                  <div className="text-sm text-gray-600">🏆 Level</div>
                </div>
              </div>

              {/* Premium-Multiplikatoren */}
              {globalMultipliers && Object.keys(globalMultipliers).length > 0 && (
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg border-2 border-purple-200">
                  <h3 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-4 flex items-center">
                    💎 Premium-Multiplikatoren
                    <span className="ml-2 text-sm bg-purple-600 text-white px-2 py-1 rounded-full">AKTIV</span>
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {Object.entries(globalMultipliers).map(([type, value]) => (
                      <div key={type} className="bg-white p-4 rounded-lg shadow-md border border-purple-100">
                        <div className="flex items-center justify-between">
                          <div>
                            <div className="text-sm text-gray-600 capitalize">
                              {type === 'totalMultiplier' ? 'Gesamt-Multiplikator' : type}
                            </div>
                            <div className="text-2xl font-bold text-purple-600">
                              ×{formatNumber(value)}
                            </div>
                          </div>
                          <div className="text-3xl">
                            {type === 'totalMultiplier' ? '🌟' : '💎'}
                          </div>
                        </div>
                        <div className="mt-2 text-xs text-purple-500 bg-purple-50 px-2 py-1 rounded">
                          Permanent aktiv
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 p-3 bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg">
                    <div className="text-sm text-purple-700">
                      <strong>💡 Info:</strong> Premium-Multiplikatoren wirken dauerhaft auf ALLE Einkommen und stapeln sich miteinander.
                    </div>
                  </div>
                </div>
              )}

              {/* Hauptmultiplikatoren */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-red-50 p-4 rounded-lg">
                  <h3 className="text-xl font-bold text-red-600 mb-2">👆 Klick-Multiplikator</h3>
                  <div className="text-3xl font-bold text-red-700 mb-4">×{formatNumber(clickMultiplier)}</div>
                  <div className="space-y-1 max-h-40 overflow-y-auto text-sm">
                    <div className="flex justify-between">
                      <span className="font-bold">Basis</span>
                      <span className="font-bold">1.00</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Player Level {playerLevel}</span>
                      <span>+{formatNumber((playerLevel - 1) * 0.1)}</span>
                    </div>
                    {(prestige?.permanentBonuses?.clickMultiplier || 0) > 0 && (
                      <div className="flex justify-between">
                        <span>Prestige Klick-Bonus</span>
                        <span>+{formatNumber((prestige.permanentBonuses.clickMultiplier || 0) * 0.5)}</span>
                      </div>
                    )}
                    {upgrades.fertilizer > 0 && (
                      <div className="flex justify-between">
                        <span>Dünger (Lv.{upgrades.fertilizer})</span>
                        <span>+{formatNumber(upgrades.fertilizer * 0.2)}</span>
                      </div>
                    )}
                    {upgrades.wateringCan > 0 && (
                      <div className="flex justify-between">
                        <span>Gießkanne (Lv.{upgrades.wateringCan})</span>
                        <span>+{formatNumber(upgrades.wateringCan * 0.15)}</span>
                      </div>
                    )}
                    {upgrades.luckCharm > 0 && (
                      <div className="flex justify-between">
                        <span>Glücksbringer (Lv.{upgrades.luckCharm})</span>
                        <span>+{formatNumber(upgrades.luckCharm * 0.1)}</span>
                      </div>
                    )}
                    {upgrades.megaMultiplier > 0 && (
                      <div className="flex justify-between">
                        <span>Mega-Multiplikator (Lv.{upgrades.megaMultiplier})</span>
                        <span>+{formatNumber(upgrades.megaMultiplier * 0.5)}</span>
                      </div>
                    )}
                    {upgrades.quantumShovel > 0 && (
                      <div className="flex justify-between">
                        <span>Quantum-Schaufel (Lv.{upgrades.quantumShovel})</span>
                        <span className="text-red-600 font-bold">×{1 + upgrades.quantumShovel}</span>
                      </div>
                    )}
                    {gardenAreas.goldMine.level > 0 && (
                      <div className="flex justify-between">
                        <span>Goldmine (Lv.{gardenAreas.goldMine.level})</span>
                        <span>+{formatNumber(gardenAreas.goldMine.level * 0.05)}</span>
                      </div>
                    )}
                    {gardenAreas.treasureVault.level > 0 && (
                      <div className="flex justify-between">
                        <span>Schatzkammer (Lv.{gardenAreas.treasureVault.level})</span>
                        <span>+{formatNumber(gardenAreas.treasureVault.level * 0.08)}</span>
                      </div>
                    )}
                    {gardenAreas.alchemyLab.level > 0 && (
                      <div className="flex justify-between">
                        <span>Alchemie-Labor (Lv.{gardenAreas.alchemyLab.level})</span>
                        <span>+{formatNumber(gardenAreas.alchemyLab.level * 0.12)}</span>
                      </div>
                    )}
                    {gardenAreas.magicForge.level > 0 && (
                      <div className="flex justify-between">
                        <span>Magische Schmiede (Lv.{gardenAreas.magicForge.level})</span>
                        <span>+{formatNumber(gardenAreas.magicForge.level * 0.15)}</span>
                      </div>
                    )}
                    {powerUps.megaMultiplier.isActive && (
                      <div className="flex justify-between">
                        <span>🔥 Mega-Multiplikator Power-Up</span>
                        <span className="text-red-600 font-bold">×5</span>
                      </div>
                    )}
                    {powerUps.infiniteEnergy.isActive && (
                      <div className="flex justify-between">
                        <span>⚡ Unendliche Energie</span>
                        <span className="text-red-600 font-bold">×2</span>
                      </div>
                    )}
                    {powerUps.cosmicBoost.isActive && (
                      <div className="flex justify-between">
                        <span>🌌 Kosmischer Boost</span>
                        <span className="text-red-600 font-bold">×10</span>
                      </div>
                    )}
                    {powerUps.dragonPower.isActive && (
                      <div className="flex justify-between">
                        <span>🐉 Drachenkraft</span>
                        <span className="text-red-600 font-bold">×25</span>
                      </div>
                    )}
                    {getCompanionBonus('clickMultiplier') > 0 && (
                      <div className="flex justify-between">
                        <span>🐾 Begleiter-Bonus</span>
                        <span>+{formatNumber(getCompanionBonus('clickMultiplier') / 100)}</span>
                      </div>
                    )}
                    {megaPrestigeMultiplier > 1 && (
                      <div className="flex justify-between">
                        <span>🌟 Mega-Prestige Global</span>
                        <span className="text-red-600 font-bold">×{formatNumber(megaPrestigeMultiplier)}</span>
                      </div>
                    )}
                    {globalMultipliers?.totalMultiplier && globalMultipliers.totalMultiplier > 1 && (
                      <div className="flex justify-between">
                        <span className="text-purple-600">💎 Premium-Multiplikator</span>
                        <span className="text-purple-600 font-bold">×{formatNumber(globalMultipliers.totalMultiplier)}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="bg-green-50 p-4 rounded-lg">
                  <h3 className="text-xl font-bold text-green-600 mb-2">💰 Münzen pro Sekunde</h3>
                  <div className="text-3xl font-bold text-green-700 mb-4">{formatNumber(coinsPerSecond)}/s</div>
                  <div className="space-y-1 max-h-40 overflow-y-auto text-sm">
                    {autoClickPower > 0 && (
                      <div className="flex justify-between">
                        <span className="font-bold">Auto-Klicker Basis</span>
                        <span className="font-bold">{formatNumber(autoClickPower)}</span>
                      </div>
                    )}
                    {(prestige?.permanentBonuses?.autoClickerEfficiency || 0) > 0 && (
                      <div className="flex justify-between">
                        <span>Prestige Auto-Klicker Effizienz</span>
                        <span className="text-green-600 font-bold">×{formatNumber(1 + (prestige.permanentBonuses.autoClickerEfficiency || 0) * 0.3)}</span>
                      </div>
                    )}
                    {upgrades.autoHarvester > 0 && (
                      <div className="flex justify-between">
                        <span>Auto-Ernter (Lv.{upgrades.autoHarvester})</span>
                        <span>+{formatNumber(upgrades.autoHarvester * 2)}</span>
                      </div>
                    )}
                    {upgrades.gardenBot > 0 && (
                      <div className="flex justify-between">
                        <span>Garten-Bot (Lv.{upgrades.gardenBot})</span>
                        <span>+{formatNumber(upgrades.gardenBot * 5)}</span>
                      </div>
                    )}
                    {upgrades.rainMaker > 0 && (
                      <div className="flex justify-between">
                        <span>Regenmacher (Lv.{upgrades.rainMaker})</span>
                        <span>+{formatNumber(upgrades.rainMaker * 2)}</span>
                      </div>
                    )}
                    {upgrades.treeFarm > 0 && (
                      <div className="flex justify-between">
                        <span>Baumfarm (Lv.{upgrades.treeFarm})</span>
                        <span>+{formatNumber(upgrades.treeFarm * 3)}</span>
                      </div>
                    )}
                    {upgrades.beeHive > 0 && (
                      <div className="flex justify-between">
                        <span>Bienenstock (Lv.{upgrades.beeHive})</span>
                        <span>+{formatNumber(upgrades.beeHive * 2.5)}</span>
                      </div>
                    )}
                    {powerUps.speedBoost.isActive && (
                      <div className="flex justify-between">
                        <span>🚀 Geschwindigkeits-Boost</span>
                        <span className="text-green-600 font-bold">×2</span>
                      </div>
                    )}
                    {powerUps.timeWarp.isActive && (
                      <div className="flex justify-between">
                        <span>⏰ Zeitverzerrung</span>
                        <span className="text-green-600 font-bold">×10</span>
                      </div>
                    )}
                    {powerUps.gardenBlessing.isActive && (
                      <div className="flex justify-between">
                        <span>🌿 Garten-Segen</span>
                        <span className="text-green-600 font-bold">×3</span>
                      </div>
                    )}
                    {powerUps.clickFrenzy.isActive && (
                      <div className="flex justify-between">
                        <span>⚡ Klick-Raserei</span>
                        <span className="text-green-600 font-bold">×5</span>
                      </div>
                    )}
                    {powerUps.cosmicBoost.isActive && (
                      <div className="flex justify-between">
                        <span>🌌 Kosmischer Boost</span>
                        <span className="text-green-600 font-bold">×10</span>
                      </div>
                    )}
                    {powerUps.dragonPower.isActive && (
                      <div className="flex justify-between">
                        <span>🐉 Drachenkraft</span>
                        <span className="text-green-600 font-bold">×25</span>
                      </div>
                    )}
                    {(prestige?.permanentBonuses?.incomeMultiplier || 0) > 0 && (
                      <div className="flex justify-between">
                        <span>Prestige Einkommen-Multiplikator</span>
                        <span className="text-green-600 font-bold">×{formatNumber(1 + (prestige.permanentBonuses.incomeMultiplier || 0) * 0.25)}</span>
                      </div>
                    )}
                    {getCompanionBonus('coinPerSecond') > 0 && (
                      <div className="flex justify-between">
                        <span>🐾 Begleiter Münzen/Sek</span>
                        <span>+{formatNumber(getCompanionBonus('coinPerSecond'))}</span>
                      </div>
                    )}
                    {getCompanionBonus('autoClickPower') > 0 && (
                      <div className="flex justify-between">
                        <span>🐾 Begleiter Auto-Klick</span>
                        <span>+{formatNumber(getCompanionBonus('autoClickPower'))}</span>
                      </div>
                    )}
                    {/* Gartenbereiche-Boni */}
                    {Object.entries(gardenAreas).map(([areaKey, areaData]) => {
                      if (areaData.level === 0) return null;
                      
                      const areaName = areaKey as keyof typeof gardenAreas;
                      const areaBonus = getAreaBonus(areaName) / 60; // Pro Sekunde
                      
                      const areaIcons: Record<string, string> = {
                        lawn: '🌱',
                        flowerBed: '🌸',
                        pond: '🌊',
                        terrace: '🏡',
                        greenhouse: '🏠',
                        fountain: '⛲',
                        orchard: '🍎',
                        veggiePatch: '🥕',
                        roseGarden: '🌹',
                        japaneseGarden: '🎋',
                        wildflowerMeadow: '🌼',
                        sculptureGarden: '🗿',
                        enchantedGrove: '🧚',
                        crystalCave: '💎',
                        moonlightGarden: '🌙',
                        dragonLair: '🐉',
                        goldMine: '⛏️',
                        treasureVault: '💰',
                        alchemyLab: '⚗️',
                        magicForge: '🔥'
                      };
                      
                      const areaNames: Record<string, string> = {
                        lawn: 'Rasen',
                        flowerBed: 'Blumenbeet',
                        pond: 'Teich',
                        terrace: 'Terrasse',
                        greenhouse: 'Gewächshaus',
                        fountain: 'Brunnen',
                        orchard: 'Obstgarten',
                        veggiePatch: 'Gemüsebeet',
                        roseGarden: 'Rosengarten',
                        japaneseGarden: 'Zen-Garten',
                        wildflowerMeadow: 'Wildblumenwiese',
                        sculptureGarden: 'Skulpturengarten',
                        enchantedGrove: 'Verzauberter Hain',
                        crystalCave: 'Kristallhöhle',
                        moonlightGarden: 'Mondschein-Garten',
                        dragonLair: 'Drachenhort',
                        goldMine: 'Goldmine',
                        treasureVault: 'Schatzkammer',
                        alchemyLab: 'Alchemie-Labor',
                        magicForge: 'Magische Schmiede'
                      };
                      
                      return (
                        <div key={areaKey} className="flex justify-between">
                          <span>{areaIcons[areaKey]} {areaNames[areaKey]} (Lv.{areaData.level})</span>
                          <span>+{formatNumber(areaBonus)}/s</span>
                        </div>
                      );
                    })}
                    {megaPrestigeMultiplier > 1 && (
                      <div className="flex justify-between">
                        <span>🌟 Mega-Prestige Global</span>
                        <span className="text-green-600 font-bold">×{formatNumber(megaPrestigeMultiplier)}</span>
                      </div>
                    )}
                    {globalMultipliers?.totalMultiplier && globalMultipliers.totalMultiplier > 1 && (
                      <div className="flex justify-between">
                        <span className="text-purple-600">💎 Premium-Multiplikator</span>
                        <span className="text-purple-600 font-bold">×{formatNumber(globalMultipliers.totalMultiplier)}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Prestige & Mega-Prestige */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h3 className="text-xl font-bold text-purple-600 mb-4">✨ Prestige-Status</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Level:</span>
                      <span className="font-bold">{prestige.level}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Verfügbare Punkte:</span>
                      <span className="font-bold">{formatNumber(prestige.points)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Gesamt Punkte:</span>
                      <span className="font-bold">{formatNumber(prestige.totalPoints)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Gesamt Prestiges:</span>
                      <span className="font-bold">{prestige.totalPrestiges}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h3 className="text-xl font-bold text-yellow-600 mb-4">🌟 Mega-Prestige</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Level:</span>
                      <span className="font-bold">{prestige.megaPrestige.level}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Investierte Punkte:</span>
                      <span className="font-bold">{formatNumber(prestige.megaPrestige.totalPointsSpent)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Globaler Multiplikator:</span>
                      <span className="font-bold text-yellow-700">×{formatNumber(megaPrestigeMultiplier)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Globaler Bonus:</span>
                      <span className="font-bold text-yellow-700">{formatNumber((megaPrestigeMultiplier - 1) * 100)}%</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Begleiter-Status */}
              <div className="bg-pink-50 p-4 rounded-lg">
                <h3 className="text-xl font-bold text-pink-600 mb-4">🐾 Begleiter-Status</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-pink-700">{companions.discovered.length}</div>
                    <div className="text-sm text-gray-600">Entdeckt</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-pink-700">{companions.active.length}</div>
                    <div className="text-sm text-gray-600">Aktiv</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-pink-700">{formatNumber(getCompanionBonus('clickMultiplier'))}</div>
                    <div className="text-sm text-gray-600">Klick-Bonus %</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-pink-700">{formatNumber(getCompanionBonus('coinPerSecond'))}</div>
                    <div className="text-sm text-gray-600">Münzen/Sek</div>
                  </div>
                </div>
              </div>

              {/* Achievements */}
              <div className="bg-orange-50 p-4 rounded-lg">
                <h3 className="text-xl font-bold text-orange-600 mb-4">🏆 Errungenschaften</h3>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
                  <div className="flex justify-between">
                    <span>Gesamt Klicks:</span>
                    <span className="font-bold">{formatNumber(achievements.totalClicks)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Verdiente Münzen:</span>
                    <span className="font-bold">{formatNumber(achievements.totalCoinsEarned)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Renovierte Bereiche:</span>
                    <span className="font-bold">{achievements.areasRenovated}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Match-3 Siege:</span>
                    <span className="font-bold">{achievements.matchThreeWins}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Gekaufte Upgrades:</span>
                    <span className="font-bold">{achievements.upgradesPurchased}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Genutzte Power-Ups:</span>
                    <span className="font-bold">{achievements.powerUpsUsed}</span>
                  </div>
                </div>
              </div>

              {/* Zahlenformat-Übersetzungen */}
              <NumberFormatGuide />
              
              {/* Einstellungen Button */}
              <div className="mt-6 pt-6 border-t border-gray-200">
                <button
                  onClick={() => {
                    if (onOpenSettings) {
                      onToggle ? onToggle() : setInternalIsOpen(false); // Schließe das Stats-Overlay
                      onOpenSettings(); // Öffne die Einstellungen
                    }
                  }}
                  className="w-full bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-bold py-4 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
                >
                  <div className="flex items-center justify-center gap-3">
                    <span className="text-2xl">⚙️</span>
                    <span className="text-lg">Einstellungen</span>
                  </div>
                  <div className="text-sm opacity-80 mt-1">
                    Spiel-Einstellungen anpassen
                  </div>
                </button>
              </div>

              {/* Copyright Information */}
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="text-center text-gray-500 text-sm">
                  <div className="flex items-center justify-center gap-2">
                    <span>©</span>
                    <span>2025 Manuel Schweitzer</span>
                  </div>
                  <div className="text-xs mt-1 opacity-80">
                    VibeGarden - Ein Garten-Idle-Spiel
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatsOverlay; 